import { useState } from "react";
import { toast } from "sonner";
import { FadeUp, MaskedLineInView, Page } from "@/components/Reveal";
import PageHero from "@/components/PageHero";
import FAQSection from "@/components/FAQSection";
import SiteEnd from "@/components/SiteEnd";

export default function Contact() {
  const [form, setForm] = useState({ name: "", phone: "", email: "", message: "" });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim()) {
      toast.error("Please share at least your name and email.");
      return;
    }
    toast.success("Thanks for reaching out! We'll get back to you within 1–2 business days.");
    setForm({ name: "", phone: "", email: "", message: "" });
  };

  const set = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  return (
    <Page testId="contact-page">
      <PageHero title="Contact Us" testId="contact-page-heading" />

      <section className="relative z-10 w-full px-6">
        <div className="glass-surface relative rounded-[32px] py-14 sm:py-24 overflow-hidden">
          <div className="stripes-overlay" aria-hidden="true" />
          <div className="relative site-container grid grid-cols-1 lg:grid-cols-2 gap-14 items-start">
            <div>
              <h2 className="text-4xl sm:text-[44px] font-semibold tracking-tight leading-tight">
                <MaskedLineInView>Got a Project in</MaskedLineInView>
                <MaskedLineInView delay={0.1}>
                  <span>Mind? <span className="text-[#8C5EBA]">Say hello!</span></span>
                </MaskedLineInView>
              </h2>
              <FadeUp delay={0.2}>
                <p className="mt-6 text-base leading-relaxed text-[#111]/60 max-w-sm">
                  Tell us about your project, question, or idea.
                  <br />
                  We'll get back to you within 1–2 business days.
                </p>
              </FadeUp>
            </div>

            <FadeUp delay={0.15}>
              <form
                data-testid="contact-form"
                onSubmit={handleSubmit}
                className="rounded-3xl p-8 sm:p-12 flex flex-col gap-5"
                style={{ background: "rgba(255,255,255,0.9)", boxShadow: "0 24px 60px rgba(17,17,17,0.10)" }}
              >
                <input
                  data-testid="contact-input-name"
                  className="opho-input"
                  placeholder="What's your name?"
                  value={form.name}
                  onChange={set("name")}
                />
                <input
                  data-testid="contact-input-phone"
                  className="opho-input"
                  placeholder="What's your phone number?"
                  value={form.phone}
                  onChange={set("phone")}
                />
                <input
                  data-testid="contact-input-email"
                  type="email"
                  className="opho-input"
                  placeholder="What's your email?"
                  value={form.email}
                  onChange={set("email")}
                />
                <textarea
                  data-testid="contact-input-message"
                  className="opho-input min-h-[130px] resize-none"
                  placeholder="Describe your interest"
                  value={form.message}
                  onChange={set("message")}
                />
                <button data-testid="contact-submit-btn" type="submit" className="btn-pill btn-dark w-full mt-2 !py-3.5 text-[15px]">
                  Submit
                </button>
              </form>
            </FadeUp>
          </div>
        </div>
      </section>

      <FAQSection />
      <SiteEnd />
    </Page>
  );
}
